export default "__VITE_ASSET__59d30964__"